import { render, staticRenderFns } from "./TraceTemplate.vue?vue&type=template&id=b0d68070&scoped=true&"
import script from "./TraceTemplate.vue?vue&type=script&lang=js&"
export * from "./TraceTemplate.vue?vue&type=script&lang=js&"
import style0 from "./TraceTemplate.vue?vue&type=style&index=0&id=b0d68070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d68070",
  null
  
)

export default component.exports